// Persists the last selected household so a fresh page load (no URL param)
// restores it. Resolution order: URL param > this storage > server default
// (`User#current_household`).

export const HOUSEHOLD_HINT_STORAGE_KEY = 'lastAccessedHouseholdId';
export const HOUSEHOLD_URL_PARAM = 'householdId';

export function readLastAccessedHouseholdId(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage.getItem(HOUSEHOLD_HINT_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeLastAccessedHouseholdId(householdId: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(HOUSEHOLD_HINT_STORAGE_KEY, householdId);
  } catch {
    // storage quota / privacy mode — hint is best-effort.
  }
}

export function clearLastAccessedHouseholdId(): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.removeItem(HOUSEHOLD_HINT_STORAGE_KEY);
  } catch {
    // ignore
  }
}
